import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_create_attachment_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { attachment: Blob, file_name: string }): Promise<{ attachment_id?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.attachment)) {
      $missingRequiredInParams.push('\'attachment\'');
    }
    if (isNil($inParams.file_name)) {
      $missingRequiredInParams.push('\'file_name\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    $url += `?inParams=${encodeURIComponent(JSON.stringify(omit($inParams, ['attachment'])))}`;
    const $body = $inParams.attachment;
    this.$utils.http.setBlobHeadersToHttpClientOptions($body, $options);
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

